import FormControl from "./form-control";

class Intervention {
    interventionType = null;
    templates = {
        snacks: null,
        supplements: null,
        liquidMeals: null,
    };

    energy = null;
    protein = null;

    inputs = {
        $energy: null,
        $protein: null,
        $amount: null,
        $liquidMeal: null,
        $frequency: null,
    };

    outputs = {
        $energy: null,
        $protein: null,
    };

    values = {
        energy: 0,
        protein: 0,
    };

    supplement = {
        energy: 0,
        protein: 0,
        amount: 1,
    };

    constructor($el, id, interventions, oldValues) {
        this.id = id;
        this.$el = $el;
        this.interventions = interventions;
        this.$selectIntervention = this.$el.find('[data-intervention="type"]');
        this.$container = this.$el.find('[data-intervention="container"]');

        this.templates.snacks = document.querySelector(
            "#intervention-fields-snacks"
        );
        this.templates.supplements = document.querySelector(
            "#intervention-fields-supplements"
        );
        this.templates.liquidMeals = document.querySelector(
            "#intervention-fields-liquid-meals"
        );

        this.outputs.$energy = this.$el.find(
            '[data-intervention="energy-logged"]'
        );
        this.outputs.$protein = this.$el.find(
            '[data-intervention="protein-logged"]'
        );

        this.$delete = this.$el.find('[data-intervention="delete"]');
        this.oldValues = oldValues;

        this.init();
    }

    init = () => {
        this.$delete.on("click", this.deleteIntervention);
        this.$selectIntervention.on(
            "change",
            this.interventionTypeChangeHandler
        );

        if (this.oldValues) {
            this.initWithOldValues();
        }
    };

    initWithOldValues = () => {
        let intervention_type_id =
            this.oldValues.intervention_type_id.intervention_type_id;

        // set default intervention_subtype_id
        let intervention_subtype_id =
            this.oldValues.intervention_type_id.intervention_subtype_id;

        if (!intervention_subtype_id) {
            switch (intervention_type_id) {
                case 1:
                    intervention_subtype_id = 1;
                    break;
                case 2:
                    intervention_subtype_id = 3;
                    break;
                case 3:
                    intervention_subtype_id = 4;
                    break;
                case 4:
                    intervention_subtype_id = 5;
                    break;
            }
        }

        // let intervention_subtype_id = this.oldValues.intervention_type_id
        //     .intervention_subtype_id
        //     ? this.oldValues.intervention_type_id.intervention_subtype_id
        //     : 1;
        this.$selectIntervention.val(
            `{"intervention_type_id":"${intervention_type_id}","intervention_subtype_id":"${intervention_subtype_id}"}`
        );
        // const intervention_type_id = JSON.stringify(
        //     this.oldValues.intervention_type_id
        // );
        // console.log("intervention_type_id", intervention_type_id);
        // this.$selectIntervention.val(
        //     JSON.stringify(this.oldValues.intervention_type_id)
        // );
        this.$selectIntervention.trigger("change");
    };

    prepareInputs = () => {
        this.$el.find(".form-control").each((i, el) => {
            new FormControl($(el));
        });

        // get inputs
        this.inputs.$energy = this.$el.find('[data-intervention="energy"]');
        this.inputs.$protein = this.$el.find('[data-intervention="protein"]');
        this.inputs.$amount = this.$el.find('[data-intervention="amount"]');
        this.inputs.$liquidMeal = this.$el.find(
            '[data-intervention="liquid-meal"]'
        );
        this.inputs.$frequency = this.$el.find(
            '[data-intervention="frequency"]'
        );
        this.inputs.$notes = this.$el.find('[data-intervention="notes"]');

        // get supplement values
        switch (this.interventionType) {
            case "supplements":
                const $interventionType =
                    this.$selectIntervention.find(":selected");

                this.supplement.energy = $interventionType.data("energy");
                this.supplement.protein = $interventionType.data("protein");

                break;
        }

        this.bindInputEvents();

        // set old values
        if (this.oldValues) {
            switch (this.interventionType) {
                case "snacks":
                    this.inputs.$energy.val(this.oldValues.energy);
                    this.inputs.$protein.val(this.oldValues.protein);
                    this.inputs.$notes.val(this.oldValues.notes);

                    this.inputs.$energy.trigger("change");
                    this.inputs.$protein.trigger("change");
                    break;

                case "supplements":
                    this.inputs.$amount.val(this.oldValues.amount);
                    this.inputs.$notes.val(this.oldValues.notes);

                    this.inputs.$amount.trigger("change");
                    this.inputs.$notes.trigger("change");

                    break;

                case "liquidMeals":
                    this.inputs.$liquidMeal.val(this.oldValues.liquid_meal_id);
                    this.inputs.$frequency.val(this.oldValues.frequency);
                    this.inputs.$notes.val(this.oldValues.notes);

                    this.inputs.$liquidMeal.trigger("change");
                    this.inputs.$frequency.trigger("change");
                    this.inputs.$notes.trigger("change");

                    break;

                default:
                    break;
            }

            this.oldValues = null;
        }
    };

    bindInputEvents = () => {
        this.inputs.$energy.on("change", this.inputChangeHandler);
        this.inputs.$protein.on("change", this.inputChangeHandler);
        this.inputs.$amount.on("change", this.inputChangeHandler);
        this.inputs.$liquidMeal.on("change", this.liquidMealsChangeHandler);
        this.inputs.$liquidMeal.on("change", this.inputChangeHandler);
        this.inputs.$frequency.on("change", this.inputChangeHandler);

        this.displayValues();
    };

    inputChangeHandler = () => {
        switch (this.interventionType) {
            case "snacks":
                this.values.energy = parseInt(
                    this.inputs.$energy.val() ? this.inputs.$energy.val() : 0,
                    10
                );
                this.values.protein = parseInt(
                    this.inputs.$protein.val() ? this.inputs.$protein.val() : 0,
                    10
                );
                break;
            case "supplements":
                const amount = this.inputs.$amount.val()
                    ? this.toInt(this.inputs.$amount.val())
                    : 0;
                this.values.energy = this.toInt(
                    this.supplement.energy * amount
                );
                this.values.protein = this.toInt(
                    this.supplement.protein * amount
                );
                break;
            case "liquidMeals":
                const frequency = this.inputs.$frequency.val()
                    ? this.toInt(this.inputs.$frequency.val())
                    : 0;

                this.values.energy = this.toInt(
                    this.supplement.energy * this.supplement.amount * frequency
                );
                this.values.protein = this.toInt(
                    this.supplement.protein * this.supplement.amount * frequency
                );

                break;
        }

        this.displayValues();
        this.interventions.calculateTotal();
    };

    liquidMealsChangeHandler = () => {
        const $liquidMeal = this.inputs.$liquidMeal.find(":selected");

        this.supplement.energy = $liquidMeal.data("energy")
            ? $liquidMeal.data("energy")
            : 0;
        this.supplement.protein = $liquidMeal.data("protein")
            ? $liquidMeal.data("protein")
            : 0;
        this.supplement.amount = $liquidMeal.data("amount")
            ? $liquidMeal.data("amount")
            : 0;
    };

    displayValues = () => {
        this.outputs.$energy.text(this.values.energy);
        this.outputs.$protein.text(this.values.protein);
    };

    deleteIntervention = (e) => {
        e.preventDefault();

        if (confirm("Wollen Sie die Intervention wirklich löschen?")) {
            this.interventions.deleteIntervention(this.id);
        }
    };

    interventionTypeChangeHandler = () => {
        this.resetInfos();
        this.$container.empty();

        let template = null;

        console.log(this.$selectIntervention.val());

        const intervention_ids = JSON.parse(this.$selectIntervention.val());

        switch (intervention_ids.intervention_type_id) {
            case "1":
                template = this.templates.snacks.cloneNode(true);
                this.interventionType = "snacks";
                break;
            case "2":
            case "4":
                template = this.templates.supplements.cloneNode(true);
                this.interventionType = "supplements";
                break;
            case "3":
                template = this.templates.liquidMeals.cloneNode(true);
                this.interventionType = "liquidMeals";
                break;
        }

        if (template) {
            template.innerHTML = template.innerHTML.replaceAll(
                "%index%",
                this.id
            );

            // clone template
            const clone = document.importNode(template.content, true);
            this.$container.append(clone);

            this.interventions.adjustSliderHeight();

            this.prepareInputs();
        }
    };

    resetInfos = () => {
        this.values.energy = 0;
        this.values.protein = 0;

        this.supplement.energy = 0;
        this.supplement.protein = 0;
        this.supplement.amount = 1;
    };

    toInt = (number) => {
        return parseInt(number, 10);
    };
}

export default Intervention;
